import { RateAssetForm } from '@/types';
import { serviceDirectoryApiClient } from '@/services/service-directory';

class Social {
  rateAsset = async (formRateAsset: RateAssetForm, socialUserToken: string) => {
    const response = await serviceDirectoryApiClient.post(
      `visitors/ratings`,
      { ...formRateAsset },
      {
        headers: {
          socialAuthorization: socialUserToken,
        },
      }
    );
    return response.data;
  };

  fetchAssetSocial = async (socialUserToken: string) => {
    const response = await serviceDirectoryApiClient.get(`visitors/ratings`, {
      headers: {
        socialAuthorization: socialUserToken,
      },
    });
    return response.data;
  };

  exchangeSocialToken = async (socialToken: string, socialNetwork: string, email?: string, fullName?: string) => {
    const response = await serviceDirectoryApiClient.post('visitors', {
      accessToken: socialToken,
      socialNetwork,
      email,
      fullName,
    });
    return response.data;
  };

  exchangeSocialTokenLinkedin = async (code: string) => {
    const response = await serviceDirectoryApiClient.get(`visitors/exchange-token-linkedin?code=${code}`);
    return response.data;
  };

  fetchListUserSocial = async (pageNumber: number, pageSize: number, sort?: string, searchText?: string) => {
    const response = await serviceDirectoryApiClient.get(`visitors`, {
      params: {
        pageNumber,
        pageSize,
        searchText,
        sort,
      },
    });
    return response.data;
  };
}

export const SocialInstance = new Social();
